export default {
  // Locales
  localeSwitch: {
    de: 'German',
    en: 'English',
  },

  common: {
    noEntries: 'Keine Einträge vorhanden',
    pagination: {
      previous: 'prev',
      next: 'next',
      info: 'No entries | 1 Entry | {start} - {end} of {totalItems} Entries'
    }
  },

  counts: {
    tags: 'No Tags | 1 Tag | {count} Tags',
    articles: 'No Articles | 1 Article | {count} Articles',
    comments : 'No Comments | 1 Comment | {count} Comments',
    members: 'No Members | 1 Memeber | {count} Mmebers',
    recipients: 'No Recipients | 1 Recipient | {count} Recipients',
    posts: 'No posts | 1 post | {count} posts',
    new_posts: 'No new posts | 1 new post | {count} new posts',
    entries: 'No entries | 1 entry | {count} entries',
    groups: 'No groups | 1 group | {count} groups'
  },

  password: {
    hint: 'Please choose a password with at least 10 characters, including letters, numbers and special characters.',
    indicator: {
      percent_0: 'Unsecure',
      percent_25: 'Unsecure',
      percent_50: 'Still not good',
      percent_75: 'Getting better',
      percent_100: 'Awesome'
    }
  },

  // Pages
  p: {
    // Home
    home: {
      section: {
        demo: {
          message: {
            description: 'Let us explain to you in a personal online demo how Foldaz works - free of charge and without obligation, of course.',
          },
          title: 'Arrange a demo and get to know foldaz.',
          form: {
            successMsg: 'Vielen Dank!'
          }
        },
        guarantee: {
          message: {
            description: 'foldaz is a software as a service tool for professional users. We respect European data protection law, we host exclusively on German servers and we do not create profiles of our users or sell data of our users. foldaz is therefore also compliant for large companies.',
          },
          title: 'Privacy of your Data',
        },
        intro: {
          label: {
            demo: 'Demo anfragen',
            features: 'More about the functions.',
            signin: 'Zum Login',
          },
          message: {
            description: 'Chatting can be done with many tools. But what about the real information everyone needs? And how does a team learn from each other on the side? Quite simply: with Foldaz. Foldaz channels all kinds of information, making it tangible and manageable.',
            signin: 'Schon angemeldet?',
          },
          title: 'Teams Collect & Share with Foldaz',
        },
        testimonials: {
          message: {
            description: 'We show anoymised examples of practical use, as we do not communicate customer names publicly.',
          },
          item: [
            {
              name: 'Simon',
              position: 'PR-Berater',
              quote: '„In der PR muss ich mit stetig in neue Themen einarbeiten. Seit wir Foldaz in der Agentur verwenden, haben wir endlich einen Ort wo alles zusammen läuft - egal ob aus dem Web, vom Kunden oder von unseren Rechnern. Themenrecherche, das Screening der Medien, Konkurrenzbeobachtung - all das ist so viel effizienter und das ganze Team profitiert davon. Foldaz ist für mich zu einem unverzichtbaren Tool geworden.“',
              avatar: 'simon.png'
            },
            {
              name: 'Alan',
              position: 'Board Member',
              quote: '„Ich bin ständig unterwegs und sauge dabei viele Informationen auf, die ich irgendwo ablegen und strukturieren muss. Mit Foldaz ist das ganz einfach und vor allem kann auch mein Team direkt sehen, was ich wieder alles Neues entdeckt habe. Dinge, die ich anderen weitergeben möchte, kann ich außerdem schnell zusammenstellen und teilen. Das macht mir das Leben wirklich einfacher.“',
              avatar: 'simon.png'
            },
            {
              name: 'Georg',
              position: 'Startup Gründer',
              quote: '„Ich baue gerade mein Startup auf. Für mein Produkt und mein Marketing suche ich ständig nach Infos, die ich mit Foldaz sehr einfach festhalten und teilen kann und meine Co-Founder wissen so auch immer, woran ich gerade sitze. Ich finde es beruhigend, dass ich wirklich alles an einem Ort habe, wo ich es jederzeit finden und nutzen kann. So geht mir nichts mehr verloren und auch spontane Dinge lassen sich leicht festhalten.“',
              avatar: 'simon.png'
            },
            {
              name: 'Céline',
              position: 'Musikerin & Kulturschaffende',
              quote: '„Ich bin im Kulturbereich tätig und organisiere mit Partnern kleinere und größere musikalische Events. Meine Projektpartner sind meist weit verstreut und manchmal auch etwas chaotisch. Da ist es super, dass ich alle Infos gut strukturieren kann und auch den anderen jederzeit alles nötige zugänglich machen kann. Ohne Foldaz das wäre das unendlich viel anstrengender. “',
              avatar: 'bianca.png'
            },
          ],
          title: 'How Companies use foldaz',
        },
        overview: {
          message: {
            anonym: 'Anonymous access statistics',
            create: 'Creation of own contents via text editor',
            comment: 'Users can comment on content items',
            description: 'heck out the overview of functionalities',
            embed: 'Embedding of video and audio data (e.g. YouTube, Vimeo, Soundcloud etc.)',
            import: 'Import web content with just a few clicks (text, images, video)',
            newsletter: 'Create newsletters and documents with a few clicks without layout problems',
            roles: 'Various access rights for admin, editor, guest editor, reader',
            upload: 'Upload of own documents (e.g. pictures, PDF, Word)',
          },
          title: 'The Core Features',
        },
      }
    },
    // Clients
    clientPage: {
      navigation: {
        members : 'Members',
        tags: 'Tags',
        theme: 'Theme',
        settings: 'Account',
        invitations: 'Invitations'
      },
    },
    clientInvitations: {
      title: 'Invitations'
    },
    clientMembersPage: {
      title: 'Members'
    },
    clientThemePage: {
      title: 'Theme',
      btnSave: 'Save changes',
      btnReset: 'Reset changes',
      btnLoadDefaults: 'Load defaults'
    },
    clientTagsPage: {
      title: 'Tags',
      form: {
        action: {
          submit: 'Save'
        }
      }
    },
    clientSettingsPage: {
      form: {
        action: {
          submit: 'Save',
        },
        label: {
          email_blacklist    : 'Blacklist',
          email_whitelist    : 'Whitelist',
          logoSVG            : 'SVG Logo',
          name               : 'Name',
          owner              : 'Owner',
          signup_enabled     : 'Signup',
          signup_enabled_hint: 'Allow registration without invitation',
          theme              : 'Theme',
          workspace          : 'Workspace',
          external: 'Opening behaviour',
          external_hint: 'open source url',
          shareable: 'Sharing',
          shareable_hint: 'sharing is allowed',
          logo: 'SVG Logo',
          logo_placeholder: 'No file choosen',
          email_signature: 'E-Mail Signature'
        },
      },
      title: 'Account Settings',
    },
    // Contents
    contentPage: {
      form: {
        action: {
          submitComment: 'Submit',
        },
        placeholder: {
          writeComment: 'Write a comment',
        },
      },
      label: {
        author     : 'Author',
        countries  : 'Countries',
        createdAt  : 'Created at…',
        priority   : 'Priority',
        publishedAt: 'Published at…',
        share      : 'Share',
        source     : 'Source',
        tags       : 'Tags',
        user       : 'Created from…',
        views      : 'Views',
      },
      title: {
        comments : '0 comments | 1 comment | {count} comments',
        documents: 'Documents',
        meta     : 'More',
      },
    },
    // Folders
    foldersDetailPage: {
      message: {
        empty: 'No entries',
      },
    },
    // Invitations
    confirmInvitationPage: {
      message: {
        success: 'Einladung erfolgreich bestätigt, das Passwort für die Anmeldung erhalten Sie per E-Mail.',
        error  : 'Einladung nicht mehr gültig oder wurde bereits bestätigt.',
      },
      title: 'Einladung bestätigen',
    },
    // Settings
    destroyProfileSettings: {
      form: {
        action: {
          submit: 'Close Account',
        },
        label: {
          currentPassword: 'Current Password',
        },
      },
      title: 'Close Account',
    },
    emailSettings: {
      form: {
        action: {
          submit: 'Change E-Mail Address',
        },
        label: {
          password         : 'Current Password',
          email            : 'New E-Mail Address',
          emailConfirmation: 'Repeat new E-Mail Address',
        },
      },
      title: 'Change E-Mail Address',
    },
    passwordSettings: {
      form: {
        action: {
          submit: 'Change password',
        },
        label: {
          currentPassword     : 'Current Password',
          password            : 'New password',
          passwordConfirmation: 'Repeat new password',
        },
      },
      title: 'Change Password',
    },
    profileSettings: {
      form: {
        action: {
          submit: 'Save',
        },
        labels: {
          firstName      : 'First name',
          jobtitle       : 'Job title',
          lastName       : 'Last name',
          salutation     : 'Salutation',
          interests: 'Interests'
        },
      },
      title: 'Account',
    },
    settingsPage: {
      title: 'Settings',
      navigation: {
        close_profile: 'Close Account',
        email        : 'E-Mail Address',
        password     : 'Password',
        profile      : 'Account',
      },
    },
    // Stream
    streamPage: {
      label: {
        loadingInProgress: 'loading ...',
        loadMoreContent  : 'read more',
        newEntries       : 'no new entry | 1 new entry | {count} new entries',
      },
      title: 'Stream',
    },
    // Teams
    teamMembersPage: {
      title: 'Members',
    },
    teamPage: {
      navigation: {
        settings: 'Settings',
        members : 'Members',
      },
      title: 'Teams',
    },
    teamSettingsPage: {
      form: {
        action: {
          submit: 'Save',
        },
        label: {
          name: 'Name',
        },
      },
      title: 'Settings',
    },
    teamsPage: {
      title: 'Teams',
    },
    // Auth
    confirmPasswordResetPage: {
      title: 'Choose a new password',
    },
    pageNotFound: {
      title: '404',
      message: {
        pageNotFound: 'Page not found',
      },
    },
    passwordResetPage: {
      title: 'Reset Password',
    },
    signInPage: {
      title: 'Sign-in',
    },
    signUpPage: {
      title: 'Sign-up',
    },
  },

  // Components
  c: {
    // App
    confirmModal: {
      form: {
        action: {
          confirm: 'Ok',
          cancel : 'Abbrechen',
        },
      },
    },
    // Demo Form
    demoForm: {
      form: {
        action: {
          submit: 'Absenden',
        },
        label: {
          company: 'Firmenname',
          name: 'Ansprechpartner',
          email: 'Mailadresse',
          phone: 'Telefon',
        },
        placeholder: {
          company: 'Firmenname',
          name: 'Ansprechpartner',
          email: 'Mailadresse',
          phone: 'Telefon',
        }
      },
    },
    // Auth
    newPasswordForm: {
      form: {
        action: {
          signin: 'Anmelden',
          submit: 'Passwort ändern',
        },
        label: {
          newPassword            : 'Neues Passwort',
          newPasswordConfirmation: 'Passwort wiederholen',
        },
      },
    },
    passwordResetForm: {
      form: {
        action: {
          signin: 'Anmelden',
          submit: 'Passwort zurücksetzen',
        },
        label: {
          email    : 'E-Mail',
          workspace: 'Workspace',
        },
      },
    },
    signInForm: {
      form: {
        action: {
          signup: 'Registrieren',
          submit: 'Anmelden',
        },
        label: {
          email        : 'E-Mail',
          password     : 'Passwort',
          passwordReset: 'Passwort vergessen?',
          workspace    : 'Workspace',
          hintFalse    : ' ',
          hintTrue     : ' '
        },
      },
    },
    signUpForm: {
      form: {
        action: {
          signup: 'Registrieren',
          submit: 'Anmelden',
        },
        label: {
          email                : 'E-Mail',
          password             : 'Passwort',
          password_confirmation: 'Passwort',
          workspace            : 'Workspace',
        },
      },
    },
    // Clients
    clientMember: {
      createdAt: 'Registered on:',
      teams: 'Teams: {teamsCount}',
      label: {
        all: 'All roles',
        owner: 'Owner',
        admin: 'Admin',
        editor: 'Editor',
        reader: 'Reader',
        first_name: 'Name',
        email: 'E-Mail',
        created_at: 'Created at',
        memberships_count: 'Teams count',
      },
    },
    // Contents
    contentControls: {
      navigation: {
        filter : 'Filter',
        members: 'Mitglieder',
        share  : 'Share',
      },
    },
    contentFilterDetails: {
      label: {
        countries       : 'Länder',
        createdAt       : 'Erstellt',
        publishedAt     : 'Veröffentlicht',
        priority        : 'Priorität',
        source          : 'Quelle',
        tags            : 'Tags',
      },
    },
    contentFilterForm: {
      form: {
        action: {
          cancel: 'Cancel',
          submit: 'Submit',
        },
        label: {
          countries       : 'Countries',
          createdAtFrom   : 'Created at (from)',
          createdAtUntil  : 'Created at (until)',
          priority        : 'Priority',
          publishedAtFrom : 'Published at (from)',
          publishedAtUntil: 'Published at (until)',
          source          : 'Source',
          tags            : 'Tags',
          external        : 'Opening behaviour',
        },
        placeholder: {
          createdAtFrom   : 'DD.MM.YYYY',
          createdAtUntil  : 'DD.MM.YYYY',
          publishedAtFrom : 'DD.MM.YYYY',
          publishedAtUntil: 'DD.MM.YYYY',
        },
        options: {
          created_at: 'Created at',
          published_at: 'Published at',
          comments_count: 'Comments',
          views: 'Views',
          asc: 'Ascending',
          desc: 'Descending',
          high: 'High',
          normal: 'Normal',
          with_source_url: 'Article opens source url',
          without_source_url: 'Article opens within system'
        }
      },
    },
    contentFilterOverlay: {
      title: 'Filter',
    },
    contentForm: {
      form: {
        label: {
          author      : 'Autor',
          countries   : 'Länder',
          countries_db   : 'Länder (Regionen bitte über Tags zuweisen)',
          priority    : 'Priorität',
          publishedAt : 'Veröffentlicht am…',
          selectFolder: 'Folder auswählen',
          source      : 'Quelle',
          sourceURL   : 'URL',
          tags        : 'Tags',
          title       : 'Artikel',
        },
        placeholder: {
          publishedAt: 'DD.MM.YYYY',
        }
      },
    },
    contentLayoutSwitch: {
      navigation: {
        gridView: 'GridView',
        listView: 'ListView',
      },
    },
    contentModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Publizieren',
        },
      },
      message: {
        fetchData: 'Ziehe Daten',
      },
    },
    contentCopyModal: {
      title: 'Copy article',
      form: {
        action: {
          cancel: 'Cancel',
          submit: 'Copy',
        },
        label: {
          folder: 'Copy to',
        },
      },
    },
    contentShareModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
        label: {
          recepient: 'Empfänger',
          tags     : 'Tags',
        },
      },
    },
    // Folders
    folder: {
      label: {
        entries: 'kein Eintrag | 1 Eintrag | {count} Einträge',
      },
    },
    folderMembersOverlay: {
      title: 'Mitglieder',
    },
    folderModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Folda erstellen | Speichern',
        },
        label: {
          description: 'Beschreibung des Folda',
          name       : 'Name des Folda',
          team       : 'Team',
          title      : 'Folda erstellen | Folda bearbeiten',
        },
      },
    },
    folderSettingsOverlay: {
      title: 'Einstellungen',
      form: {
        label: {
          name: 'Name des Folda',
          description: 'Beschreibung des Folda',
          exportEnabled: 'Automatischen Widget Export aktivieren',
          exportUrl: 'Export URL',
          exportUrlHint: 'Der Automatisch Export wird beim bearbeiten oder hinzufügen von Artikel in diesem Ordner ausgeführt. Eine URL ist erst vorhanden wenn ein Export durchgeführt wurde.'
        }
      }
    },
    // Forms
    documentsInput: {
      form: {
        label: {
          add: 'Dokument auswählen',
        },
      },
    },
    formWrap: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
      },
    },
    textInput: {
      form: {
        action: {
          copyToClipboard: "Kopieren",
        },
      },
    },
    // Invitations
    invitationModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
        label: {
          email_addresses: 'E-Mail Addressen eingeben (mehrere mit Komma)',
          role           : 'Rolle',
          role_hint      : 'Mitglieder haben Admin-Rechte',
        },
      },
      title: 'Mitglied(er) hinzufügen',
    },
    // Layout
    mainFooter: {
      navigation: {
        about   : 'About us',
        contact : 'Contact us',
        howToUse: 'How to use',
        imprint : 'Imprint',
        privacy : 'Privacy',
        tos     : 'Terms of use',
        bookmarklet: 'Bookmarklet',
      },
      title: {
        about   : 'About',
        language: 'Language',
      },
    },
    mainNav: {
      navigation: {
        signin: 'Sign-In',
        signup: 'Sign-Up',
      },
      dropdown: {
        client_settings: 'Client',
        user_settings: 'Settings',
        logout: 'Logout'
      }
    },
    // Membership
    membership: {
      label: {
        owner: 'Owner',
      },
    },
    membershipModal: {
      form: {
        action: {
          cancel: 'Cancel',
          submit: 'Add | Save',
        },
        label: {
          team: 'Team',
          role: 'Role',
        },
        hint: {
          role: 'User has admin rights',
        },
      },
      title: 'Add to team | Edit membership',
    },
    // Ownership
    ownership: {
      label: {
        owner: 'Owner',
      },
    },
    // Search
    searchBar: {
      form: {
        placeholder: {
          search: 'Search for',
        },
      },
      navigation: {
        filter: 'Filter',
        share : 'Share',
      },
    },
    searchFilterForm: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Übernehmen',
        },
        label: {
          countries       : 'Länder',
          createdAtFrom   : 'Erstellt am… (ab)',
          createdAtUntil  : 'Erstellt am… (bis)',
          priority        : 'Priorität',
          publishedAtFrom : 'Veröffentlicht am… (ab)',
          publishedAtUntil: 'Veröffentlicht am… (bis)',
          source          : 'Quelle',
          tags            : 'Tags',
        },
        placeholder: {
          createdAtFrom   : 'DD.MM.YYYY',
          createdAtUntil  : 'DD.MM.YYYY',
          publishedAtFrom : 'DD.MM.YYYY',
          publishedAtUntil: 'DD.MM.YYYY',
        },
      },
    },
    searchFilterOverlay: {
      title: 'Filter',
    },
    searchResult: {
      message: {
        noEntries: 'No entries found',
        entries: 'Entry | {count} Entries',
      },
    },
    // Stream
    streamItem: {
      label: {
        createdAt: 'Created at ',
        readMore: 'read more',
      },
    },
    // Teams
    team: {
      label: {
        members: 'no Member | 1 Member | {count} Members',
      },
    },
    teamMember: {
      label: {
        owner: 'Owner',
      },
    },
    teamModal: {
      form: {
        action: {
          cancel: 'Cancel',
          submit: 'Create Team | Save',
        },
        label: {
          name: 'Team name',
        },
      },
      title: 'Create Team | Edit Team',
    },
    teamWithFolders: {
      label: {
        folders: 'No Folda | 1 Folda | {count} Foldaz',
      },
    },
    completeProfileOverlay: {
      title: 'Complete Profile',
      btnSubmit: 'Continue',
      btnLogout: 'Logout'
    },
    updatePasswordOverlay: {
      title: 'Set new password',
      form: {
        labels: {
          currentPassword: 'Current password',
          password: 'New Password',
          passwordConfirmation: 'Password confirmation'
        }
      },
      btnSubmit: 'Continue',
      btnLogout: 'Logout'
    },

    contentExportOverlay: {
      stepFormat: {
        title: 'Format',
        btnNext: 'Continue to articles',
        form: {
          label: {
            format: 'Format'
          },
          options: {
            html: 'HTML',
            pdf: 'PDF'
          }
        }
      },
      stepArticles: {
        title: 'Articles',
        btnNext: 'Continue to output'
      },
      stepOutput: {
        title: 'Output',
        btnClose: 'Close'
      }
    },

    mailingOverlay: {
      stepHistory: {
        title: 'History',
        no_entries: 'No entries available.',
        btnNew: 'Create new',
        showLatestNewsletter: 'Show latest newsletter'
      },
      stepTitle: {
        title: 'Title',
        btnNext: 'Continue to tags',
      },
      stepTags: {
        title: 'Tags',
        btnNext: 'Continue to articles',
      },
      stepArticles: {
        title: 'Articles',
        sortDropdown: {
          asc: 'Ascending',
          desc: 'Sescending'
        },
        selectDropdown: {
          selectall: 'Select all',
          deselectall: 'Deselect all'
        },
        groupedContentSelected: 'No articles selected | 1 article selected | {count} articles selected',
        btnNext: 'Continue to recipients',
        btnBack: 'Go back'
      },
      stepRecipients: {
        title: 'Recipients',
        selectDropdown: {
          selectall: 'Select all',
          deselectall: 'Deselect all'
        },
        btnNext: 'Continue to summary',
        btnBack: 'Go back'
      },
      stepSummary: {
        title: 'Summary',
        stats: {
          articles: 'Articles | Article | Articles',
          recipients: 'Recipients | Recipient | Recipients',
          groups: 'Groups | Group | Groups'
        },
        previewRecipients: 'Preview recipients',
        notification: 'Message was sent successfully!',
        btnNext: 'Send now',
        btnPreview: 'Send preview',
        btnBack: 'Go back'
      },
      stepSuccess: {
        title: 'Messages sent',
        text: 'Your messages were sent. You may close this window now. We wish you a great day.',
        btnClose: 'Close window'
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/i18n/en.js